import { IconAlertCircle, IconCircleChecked, IconCircleX, useClassnames } from '@wb-tech/ui-react';
import React, { ReactNode, useMemo } from 'react';

import style from './index.module.pcss';

interface IIconProps {
    type: string
}

export const TypedIcon = (props: IIconProps) => {
    const cn = useClassnames(style);

    const elTypeIcon = useMemo((): ReactNode => {
        switch (props.type) {
            case 'error':
                return (
                    <IconCircleX
                        svg={{
                            className: cn('notification-icon_error')
                        }}
                    />
                );
            case 'warning':
                return (
                    <IconAlertCircle
                        svg={{
                            className: cn('notification-icon_warning')
                        }}
                    />
                );
            default:
                return (
                    <IconCircleChecked
                        svg={{
                            className: cn('notification-icon_success')
                        }}
                    />
                );
        }
    }, [props, cn]);

    return (elTypeIcon);
};
